import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { DhukanDataService } from 'src/app/services/dhukan/dhukan-data.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { LoginDataService } from 'src/app/services/dhukan/login-data.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-addpaymode',
  templateUrl: './addpaymode.component.html',
  styleUrls: ['./addpaymode.component.css']
})
export class AddpaymodeComponent implements OnInit {


//Mode Values
isaddmode:boolean=false;
iseditmode:boolean=false;
isdeletemode:boolean=false;
isviewmode:boolean=false;

//Save Validation
submitted:boolean;
successfully:boolean;

paytypeColl:any=[];

//Edit Get Values
paymodeColl:any=[];
paymodeid:number=0

paymodeform=new FormGroup({         
  paymode:new FormControl('',Validators.required),           
  paytype:new FormControl('',Validators.required), 
  paymodeid:new FormControl(0),      
  inactive:new FormControl(false),     
});

isloading:boolean=false;
isprivilage:boolean=false;  
showProgress:boolean=false;
formname:String="PaymentMode";

_routerSub = Subscription.EMPTY;
_routerparamsSub = Subscription.EMPTY;
_routerLoginSub = Subscription.EMPTY

constructor(private appService: DhukanDataService,private route: ActivatedRoute,
   public router: Router,private toastr: ToastrService,private loginService:LoginDataService) { 
    this._routerSub = this.route.queryParams.subscribe(params => {
      if(params.id!==undefined){
        this.paymodeid = params.id
      }  
     });
     this.fnServiceChanges();
}


fnServiceChanges(){
  this._routerLoginSub = this.loginService.serviceloginChange.subscribe((value) => {
        if(this.loginService.fnCheckUser()){
         
          if(this.fnCheckUserPririvilage()){
            this.isloading=true;
            this.fnOnInitForm();
          }
          else{
            this.fnUserFailedForm();
          }
            
        }
        else{
          this.fnUserFailedForm();
        }
  });
}

ngOnInit() {
    try{
      if(this.loginService.fnCheckUser()){ 
        if(this.fnCheckUserPririvilage()){       
          this.isloading=true;
          this.fnOnInitForm();
        }
        else{
          this.fnUserFailedForm();
        }
      }
      else{
        this.loginService.fnGetUserRoleList();
      }
              
    }catch(ex){
      this.fnShowErrorMsg(ex);
    }
}
ngOnDestroy(): void {
  if (this._routerSub !== undefined) {
    this._routerSub.unsubscribe();
  }
  if (this._routerparamsSub !== undefined) {
    this._routerparamsSub.unsubscribe();
  }

  if (this._routerLoginSub !== undefined) {
    this._routerLoginSub.unsubscribe();
  }
}
fnOnInitForm(){
   try{
       this.isaddmode=true;
       this.paymodeform.reset();
       this.fnInitializePaymodeFormGroup(); 

       if(this.paymodeid>0){
         this.fngetPaymode();
       }

       this.fnGetPaytype();
   }catch(ex){
     this.fnShowErrorMsg(ex);
   }
}



fnCheckUserPririvilage(){
  var _check:boolean=false;
  if (this.paymodeid>0){
    _check= this.loginService.fnCheckUserRoleAction(this.formname,'ALTER')
  }else{
    _check= this.loginService.fnCheckUserRoleAction(this.formname,'CREATE')
  }

  return _check;
}

fnUserFailedForm(){
  this.isprivilage=true;
}


fnInitializePaymodeFormGroup(){
   this.paymodeform.setValue({
    paytype:'',
    paymode:'',    
    paymodeid:0,      
    inactive:false,      
   })
}



fnGetPaytype(){
  this.paytypeColl.push({name:'CASH',displayname:'Cash'})
  this.paytypeColl.push({name:'CARD',displayname:'Card'})
  this.paytypeColl.push({name:'WALLETS',displayname:'Wallets'})
  this.paytypeColl.push({name:'NETBANKING',displayname:'NetBanking'})

  
}




//Get 
fngetPaymode() {        
     var data = {
       'paymodeid':this.paymodeid,            
     }
     this.appService.getPaymode(data)
     .subscribe(
       (res)=>{                  
         this.paymodeColl=res.json().result;
         var editdata = {
           'paymodeid':this.paymodeColl[0].paymodeid,
           'paymode':this.paymodeColl[0].paymode, 
           'paytype':this.paymodeColl[0].paytype, 
           'inactive':this.paymodeColl[0].inactive,          
         }
         this.fnEditMode(editdata);
     },
     (err)=>{          
       this.toastr.error('Error', err);
     })
}

//Save Btn Click
fnSaveBtnClick(){
   try{
     this.submitted=true;
     this.successfully=false;
     //Validate
     if(this.paymodeform.valid){
         //Check
         var data = {
               'paymodeid': this.paymodeid,       
               'paytype':this.paymodeform.get('paytype').value,            
               'paymode':this.paymodeform.get('paymode').value,            
               'inactive': 0,  
               'createdby': this.loginService.fnGetModUserId(),    
               'modifiedby':this.loginService.fnGetModUserId(), 
         }
         this.appService.fnCheckPaymode(data).subscribe(
           (res)=>{
               var _checkresult=res.json().result[0].checkfield;
             
               if(_checkresult==="done"){
                     if (this.paymodeform.get('paymodeid').value>0){
                       //Update Department
                       this.fnSetPaymode(data);
                     }
                     else{
                       //Insert Department
                       this.fnInsertPaymode(data);
                     }
               }
               else{        
                     if(_checkresult==="name"){
                       this.paymodeform.controls['paytype'].setErrors({'notfound': true});
                     }
               }
         },
         (err)=>{
             this.toastr.error('Error', err);           
         });
      }
   }catch(ex){
     this.fnShowErrorMsg(ex);
   }
}

//Insert
fnInsertPaymode(data){    
 
   this.appService.fnInsertPaymode(data).subscribe(
     (res)=>{
     if(res.json().result!=""){
       this.toastr.success('', "The new paymode has been added successfully.Insert Successfully");

       this.fnInsertActivityLog('INSERT',0,data.paymode);

       this.fnClosePaymode();
     }},
     (err)=>{
       this.toastr.error('Error', err);
     });

}

//Set
fnSetPaymode(data){    

this.appService.fnSetPaymode(data).subscribe(
 (res)=>{
 if(res.json().result!=""){
     this.toastr.success('', "The paymode has been updated successfully.");

     this.fnInsertActivityLog('EDIT',this.paymodeid,data.paymode);

     this.fnClosePaymode();        
 }},
 (err)=>{
   this.toastr.error('Error', err);
 });

}

//Close
fnClosePaymode(){
try{
  this.router.navigate(['/Paymode']);
}catch(ex){
   this.fnShowErrorMsg(ex);
}
}

private fnEditMode(deptBO){

 this.paymodeform.setValue({
      paytype:deptBO.paytype,
      paymode:deptBO.paymode,      
      paymodeid:deptBO.paymodeid,
      inactive:deptBO.inactive,   
 });


this.isaddmode=false;
this.iseditmode=true;
this.isdeletemode=false;
this.isviewmode=false;
}


fnInsertActivityLog(action,refno,desc){
  try{
    var data={
      logtype:action,
      logat:this.formname,
      refnum:refno,
      logdescr:desc,
      logby:this.loginService.fnGetModUserId(),
    }
  

    this.appService.fnInsertActivity(data).subscribe(
      (res)=>{
      },
      (err)=>{
     
      });

  }catch{

  }
}



private fnShowProgress(){
  this.showProgress=true;
}
private fnHideProgress(){
  this.showProgress=false;
}

private  fnShowErrorMsg(ex){
this.toastr.warning('Internal Error', ex);       
}




}
